import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Company {
  id: string;
  name: string;
  domain: string | null;
  created_at: string;
  updated_at: string;
}

interface CompanyState {
  currentCompany: Company | null;
  loading: boolean;
  companyError: string | null;
}

const initialState: CompanyState = {
  currentCompany: null,
  loading: false,
  companyError: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCurrentCompany: (state, action: PayloadAction<Company | null>) => {
      state.currentCompany = action.payload;
      if (action.payload) {
        state.companyError = null;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCompanyError: (state, action: PayloadAction<string | null>) => {
      state.companyError = action.payload;
    },
    clearCompany: (state) => {
      state.currentCompany = null;
      state.companyError = null;
      state.loading = false;
    },
  },
});

export const { setCurrentCompany, setLoading, setCompanyError, clearCompany } = companySlice.actions;
export default companySlice.reducer;